export function formatTourHomeLabel(
  unitNumber: string,
  propertyName: string,
  building = false,
): string {
  if (building) return propertyName.trim() || 'The Hive';
  const number = unitNumber.trim().replace(/^#/, '');
  return `#${number} - ${propertyName.trim()}`;
}

function formatRoomCount(count: number, singular: string, plural: string): string {
  return `${String(count)} ${count === 1 ? singular : plural}`;
}

export function formatTourBedBath(bedrooms: number, bathrooms: number): string {
  return `${formatRoomCount(bedrooms, 'bed', 'bed')}, ${formatRoomCount(bathrooms, 'bath', 'bath')}`;
}

export interface BookedTour {
  bookingId: string;
  building: boolean;
  unitNumber: string;
  propertyName: string;
  bedrooms: number;
  bathrooms: number;
  imageUrl: string | null;
  startAt: string;
  endAt: string;
}

interface TourSlotLike {
  startAt: string;
  endAt: string;
  state: string;
  bookingId: string | null;
}

interface TourWindowLike {
  building?: boolean;
  unitNumber: string;
  propertyName: string;
  bedrooms: number;
  bathrooms: number;
  imageUrl?: string | null;
  slots: TourSlotLike[];
}

export function listBookedTours(windows: TourWindowLike[]): BookedTour[] {
  const tours: BookedTour[] = [];
  for (const window of windows) {
    for (const slot of window.slots) {
      if (slot.state !== 'yours' || !slot.bookingId) continue;
      tours.push({
        bookingId: slot.bookingId,
        building: window.building ?? false,
        unitNumber: window.unitNumber,
        propertyName: window.propertyName,
        bedrooms: window.bedrooms,
        bathrooms: window.bathrooms,
        imageUrl: window.imageUrl ?? null,
        startAt: slot.startAt,
        endAt: slot.endAt,
      });
    }
  }
  tours.sort((a, b) => a.startAt.localeCompare(b.startAt));
  return tours;
}
